import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { memo } from 'react';
import { Link } from 'react-router-dom';
import { CREDIT_PORTAL_URL, Span } from 'shared';
import { useSessionStorage } from '../hooks';
const logo = '/Alphaeon_Patient_Financing_Logo_SVG.svg';
function Header() {
    const { value: isOTA } = useSessionStorage('isOTA');
    const isLogoClickable = isOTA !== 'true';
    return (_jsxs("div", { className: "header", children: [isLogoClickable ? (_jsx(Link, { to: CREDIT_PORTAL_URL, children: _jsx("img", { src: logo, className: "logo", alt: "Logo", width: 224, height: 58.75 }) })) : (_jsx("img", { src: logo, className: "logo", alt: "Logo" })), _jsxs("div", { className: "wizard-header-title", children: [_jsx(LockOutlinedIcon, {}), _jsx(Span, { variant: "title-medium", bold: true, children: "Secure Application" })] })] }));
}
export default memo(Header);
